import { Auth } from "@gss/common/Auth";
import { Roles } from "@gss/common/Roles";
import type { Role } from "@gss/common/Roles";

export interface MenuNode {
    path: string;
    name: string;
    hidden?: boolean;
    roles: Role[];
}

export const resultsMenuNode: MenuNode = {
    path: "/gss-results",
    name: "Resultat",
    roles: [],
    hidden: true,
};

const newsMenuNode: MenuNode = {
    path: "/gss-news",
    name: "Nyheter",
    roles: [Roles.READER],
};

const allNodes: MenuNode[] = [
    newsMenuNode,
    {
        path: "/gss-support",
        name: "Stöd",
        roles: [Roles.READER],
    },
    {
        path: "/gss-mypage",
        name: "Mina sidor",
        roles: [Roles.CONTACT_PERSON, Roles.SURVEY_PROVIDER],
    },
    {
        path: "/gss-users",
        name: "Användare",
        roles: [Roles.CONTACT_PERSON],
    },
    {
        path: "/gss-measurements",
        name: "Mätningar",
        roles: [Roles.READER],
    },
    {
        path: "/gss-questions",
        name: "Frågebanken",
        roles: [Roles.CONTACT_PERSON, Roles.SURVEY_PROVIDER],
    },
    {
        path: "/gss-api",
        name: "API",
        roles: [Roles.SURVEY_PROVIDER],
    },
    {
        path: "/gss-admin",
        name: "Admin",
        roles: [Roles.ADMIN],
    },
    {
        path: "/gss-swagger",
        name: "Swagger",
        roles: [Roles.SURVEY_PROVIDER],
    },
    {
        path: "/gss-docs",
        name: "Dokumentation",
        roles: [Roles.ADMIN],
    },
    resultsMenuNode,
    {
        path: "/gss-health",
        name: "Hälsa",
        roles: [],
        hidden: true,
    },
];

let allowedNodes: MenuNode[] | undefined;

export function getMenuNodes(): MenuNode[] {
    allowedNodes ??= getAllowedNodes();
    return allowedNodes;
}

function getAllowedNodes(): MenuNode[] {
    return allNodes.filter((node) => {
        // No roles means accessible to all
        if (node.roles.length === 0) {
            return true;
        }
        return node.roles.some((r) => Auth.hasRole(r));
    });
}

export function getStodstrukturenUrl(): string {
    return location.hostname === "resultat.patientenkat.se"
        ? "https://stodstrukturen.patientenkat.se"
        : newsMenuNode.path;
}

export function getResultsUrl(): string {
    return location.hostname === "stodstrukturen.patientenkat.se"
        ? "https://resultat.patientenkat.se"
        : resultsMenuNode.path;
}
